// mainApi.js
import axios from "axios";

const specificPort = "https://api.asztalosoft.hu";
let activeControllers = []; // minden request ide kerül
let isLoggedOut = false;

const axiosInstance = axios.create({
  //baseURL: BASE_URL,
  baseURL: specificPort,
  headers: { "Content-Type": "application/json" },
  withCredentials: true
});

// Request interceptor
axiosInstance.interceptors.request.use((config) => {
  if (isLoggedOut) {
    // Ha logout után próbál kérni → eldobjuk
    const cancelled = new axios.Cancel("Request blocked after logout");
    cancelled.config = config;
    return Promise.reject(cancelled);
  }

  // Készítünk egy AbortController-t
  const controller = new AbortController();
  if (config.signal) {
    if (config.signal.aborted) controller.abort();
    else config.signal.addEventListener("abort", () => controller.abort(), { once: true });
  }
  config.signal = controller.signal;
  config.requestController = controller;

  // Elmentjük, hogy később megszakíthassuk
  activeControllers.push(controller);

  // Token hozzáadás, ha kell
  if (
    !(
      config.url?.endsWith("/account/login") ||
      config.url?.endsWith("/account/register")
    )
  ) {
    const token = localStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    activeControllers = activeControllers.filter(c => c !== response.config.requestController);
    return response;
  },
  (error) => {
    activeControllers = activeControllers.filter(c => c !== error.config?.requestController);
    // Ha a hiba abort miatt jött, dobjuk el csendben
    if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
      if (error.config?.rejectOnCancel) return Promise.reject(error);
      return new Promise(() => {}); // pending forever → nincs hibakezelés
    }
    return Promise.reject(error);
  }
);

// Logout helper: megszakít minden requestet
export function cancelAllRequests() {
  isLoggedOut = true;
  activeControllers.forEach((c) => c.abort());
  activeControllers = [];
  setTimeout(() => {
    isLoggedOut = false;
  }, 500); // opcionális: kis idő után engedjük újra
}

export default axiosInstance;
